import { useEffect } from "react";
import { dispatch, useConsentsSelector, UserStore } from "@nf/common";
import { useSyncCompleted } from "./useSyncWebUser";

export const useGetUserConsents = () => {
  const { completedSuccess, initialized } = useConsentsSelector();
  const isAuthProcessCompleted = useSyncCompleted();
  useEffect(() => {
    isAuthProcessCompleted &&
      !initialized &&
      !completedSuccess &&
      dispatch(UserStore.Actions.getUserConsents());
  }, [isAuthProcessCompleted, completedSuccess, initialized]);
};
